export default __webpack_public_path__ + "static/media/yxjl.eec5ca31.png";